import { render, staticRenderFns } from "./MasUserCate.vue?vue&type=template&id=69290710&scoped=true"
import script from "./MasUserCate.vue?vue&type=script&lang=js"
export * from "./MasUserCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69290710",
  null
  
)

export default component.exports